export default __webpack_public_path__ + "static/media/darkforest.5515546c.mp4";